var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Map',{staticClass:"animated fadeIn",attrs:{"type":"Nước dưới đất","config-key":"nuoc_duoi_dat"}})
}
var staticRenderFns = []

export { render, staticRenderFns }